<template>
  <div class="bq-dialog" v-show="visible">
    <div class="bq-dialog-cover" @click="hideDialog"></div>
    <div class="bq-dialog-body">
      <div class="bq-dialog-hd">
        <h3 v-if="title">{{ title }}</h3>

        <!-- 标题插槽 -->
        <slot name="header"></slot>

        <i class="bq-dialog-close" @click="onHide"></i>
      </div>

      <div class="bq-dialog-bd">
        <!-- 内容插槽 -->
        <slot></slot>
      </div>

      <div class="bq-dialog-ft">
        <!-- 尾部插槽 -->
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BQDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: String,
    onHide: Function,
    hideDialog: Function,
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
